
<div
  :class="{
    large,
    'full-width': fullWidth,
    'ws-field': $options._componentTag !== 'wds-checkbox',
    [$options._componentTag]: get($options, '_componentTag', false)
  }"
>
  <div
    class="q-checkbox-wrapper"
    :class="{ 'full-width': fullWidth }"
  >
    <q-checkbox
      ref="qfield"
      :value="localValue"
      v-bind="$attrs"
      dense
      color="ws-primary"
      class="ws-checkbox-inner"
      :class="{ error: hasError, 'full-width': fullWidth }"
      :aria-describedby="`error-message-${_uid}`"
      v-on="$listeners"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"></slot>
      </template>
    </q-checkbox>
  </div>
  <transition name="slide-fade-vertical">
    <ws-message
      v-if="hasError"
      :id="`error-message-${_uid}`"
      type="alert"
      :messages="errors"
      @remove="innerErrorMessage = null"
    />
  </transition>
</div>
